import React, {useContext} from 'react';
import {defineMessages} from 'react-intl';
import {AccessControlIndicator} from '@igp/shared/access-control';
import {Button} from '@igp/shared/components/button';
import {LocalizedText} from '@igp/shared/components/i18n';
import {ModalContext} from '@igp/shared/components/modal';

import {withAccessCheck} from '@access-control';

import {editRepaymentLogsResource} from '../permissions';

import {EditRepaymentLogForm} from './EditForm';

const localized = defineMessages({
    title: {
        id: 'AddRepaymentLogButton_title',
        defaultMessage: 'Add Repayment Entry',
    },
});

function AddRepaymentLogButtonInner() {
    const {openModal, isModalOpened} = useContext(ModalContext);
    function handleClick() {
        if (!isModalOpened) {
            openModal({
                title: <LocalizedText label={localized.title} />,
                body: <EditRepaymentLogForm />,
            });
        }
    }
    return <Button label={localized.title} disabled={isModalOpened} onClick={handleClick} />;
}

export const AddRepaymentLogButton = withAccessCheck(AddRepaymentLogButtonInner, editRepaymentLogsResource, AccessControlIndicator.Hidden);
